import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import CancelIcon from "@mui/icons-material/Cancel";
import { StatusTextType } from "../interfaces";

export const STATUS_COLORS: Record<StatusTextType, string> = {
  error: "error.main",
  warning: "warning.main",
  info: "text.secondary",
  nancie: "nancie.main",
};

export const StatusIcon = ({ status }: { status: StatusTextType }) => {
  switch (status) {
    case "error":
      return (
        <CancelIcon
          fontSize="small"
          sx={{ color: "error.main", fontSize: "1rem" }}
        />
      );
    case "warning":
      return (
        <WarningIcon
          fontSize="small"
          sx={{
            color: "warning.main",
            fontSize: "1.1rem",
            borderRadius: "8px",
          }}
        />
      );
    case "nancie":
      return (
        <ErrorIcon
          fontSize="small"
          sx={{ color: "nancie.main", fontSize: "1rem" }}
        />
      );
    case "info":
    default:
      return <ErrorIcon fontSize="small" sx={{ fontSize: "1rem" }} />;
  }
};

/**
 * Generic inline status message.
 *
 * Renders an icon + small italic text with status-based color.
 * Accepts children so it can be used with dynamic content
 * (FormattedMessage with values, conditionally built text, etc.).
 */
export const StatusMessage = ({
  status,
  children,
}: {
  status: StatusTextType;
  children: ReactNode;
}) => (
  <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
    <StatusIcon status={status} />
    <Typography
      component="p"
      sx={{
        textAlign: "left",
        margin: 0,
        fontSize: "0.812rem",
        fontStyle: "italic",
        color: STATUS_COLORS[status],
      }}
    >
      {children}
    </Typography>
  </Box>
);
